<template lang="pug">
.rent-object-features-wrapper
  .button-flex
    .button-wrapper  
      b-button(type="is-light" icon-left="plus" @click="newRentObjectBed()") Neues Bett anlegen
    .spacer.md
    CopyPasteModal(:id="id" :rentObjectType="rentObjectType" destination="Betten" @copySuccess="reloadData()")

  .card.margin-top
    //- .top(v-if="beds != rentObjectBeds.length")
      b-message(size="is-small" type="is-warning") Achtung es passt nicht! In den Stammdaten haben Sie {{bedrooms}} Schlafgelegenheiten angegeben. Momentan haben Sie aber {{rentObjectBeds.length}} angegeben.
    .main
      b-table(
        :data="rentObjectBeds",
        default-sort-direction="desc",
        default-sort="type",
        hoverable
      )
        b-table-column(field="type", label="Typ", sortable, v-slot="props")
          | {{ props.row.type }}
        b-table-column(field="location", label="Zimmer", sortable, v-slot="props")
          | {{ props.row.location }}
        b-table-column(field="length", label="Länge", sortable, v-slot="props")
          | {{ props.row.length/100 }}m
        b-table-column(field="width", label="Breite", sortable, v-slot="props")
          | {{ props.row.width/100 }}m
        b-table-column(field="height", label="Höhe", sortable, v-slot="props")
          | {{ props.row.height/100 }}m
        b-table-column(v-slot="props")
          div
            b-tooltip(label='Bearbeiten' type='is-secondary' position='is-bottom' :delay="1250")
              b-button(icon-right="pencil", type="is-secondary" @click="updateRentObjectBed(props.row)")
            .spacer.sm.inline
            b-tooltip(label='Dauerhaft löschen' type='is-danger' position='is-bottom' :delay="1250")
              b-button(icon-right="close", type="is-danger" @click="deleteRentObjectBed(props.row)")
            

  b-modal(v-model='isModalActive' has-modal-card='' trap-focus='' :destroy-on-hide='false' aria-role='dialog' aria-modal='')
    template(#default='props')
      .card.form.w320.margin-top
        .top
          h2.title.is-6(v-if="formData.id") Schlafgelegenheit aktualisieren
          h2.title.is-6(v-else) Neue Schlafgelegenheit
          ValidationObserver(v-slot="{ handleSubmit }", ref="form")
            ValidationProvider(
              name="Typ",
              rules="required",
              v-slot="{ errors, valid }"
            )
              b-field(
                label="Typ",
                label-position="on-border",
                :type="{ 'is-danger': errors[0], 'is-success': valid }",
                :message="errors"
              )
                b-select(expanded, v-model="formData.type")
                  option(
                    v-for="b in bedTypes"
                    :value="b.name"
                  ) {{ b.name }}
            b-field(grouped)
              ValidationProvider(
                name="Länge",
                rules="required",
                v-slot="{ errors, valid }"
              )
                b-field(
                  label="Länge (cm)",
                  label-position="on-border",
                  :type="{ 'is-danger': errors[0], 'is-success': valid }",
                  :message="errors"
                )
                  b-input(v-model="formData.length")
              .spacer.sm
              ValidationProvider(
                name="Breite",
                rules="required",
                v-slot="{ errors, valid }"
              )
                b-field(
                  label="Breite (cm)",
                  label-position="on-border",
                  :type="{ 'is-danger': errors[0], 'is-success': valid }",
                  :message="errors"
                )
                  b-input(v-model="formData.width")
              .spacer.sm
              ValidationProvider(
                name="Höhe",
                rules="required",
                v-slot="{ errors, valid }"
              )
                b-field(
                  label="Höhe (cm)",
                  label-position="on-border",
                  :type="{ 'is-danger': errors[0], 'is-success': valid }",
                  :message="errors"
                )
                  b-input(v-model="formData.height")
            ValidationProvider(
              name="Zimmer",
              rules="required",
              v-slot="{ errors, valid }"
            )
              b-field(
                label="Zimmer",
                label-position="on-border",
                :type="{ 'is-danger': errors[0], 'is-success': valid }",
                :message="errors"
              )
                b-select(expanded, v-model="formData.location")
                  option(
                    v-for="i in bedrooms"
                    :value="bedrooms === 1 ? 'Schlafzimmer' : 'Schlafzimmer '+ i"
                  ) {{ bedrooms === 1 ? 'Schlafzimmer' : 'Schlafzimmer '+ i }}
                  option Wohnzimmer
                  option Wohn- / Schlafzimmer

            .button-wrapper.margin-top.right
              b-button(
                type="is-light",
                @click="isModalActive = false"
              ) Abbrechen
              b-button(
                v-if="formData.id"
                type="is-primary",
                @click="handleSubmit(saveRentObjectBed)"
              ) Aktualisieren
              b-button(
                v-else
                type="is-primary",
                @click="handleSubmit(saveRentObjectBed)"
              ) Speichern
</template>

<script>
import CopyPasteModal from "@/components/molecules/CopyPasteModal.vue";

export default {
  components: {
    CopyPasteModal
  },
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    bedrooms: {
      type: Number,
      default: 0
    },
    rentObjectType: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      isModalActive: false,
      formData: {
        type: null,
        location: null,
        width: null,
        height: null,
        length: null
      },
      rentObjectBeds: [],
      bedTypes: [
        {
          name: 'Einzelbett'
        },
        {
          name: 'Doppelbett'
        },
        {
          name: 'Schlafcouch'
        },
        {
          name: 'Doppelschlafcouch'
        },
        {
          name: 'Zustellbett'
        },
        {
          name: 'Etagenbett'
        },
        {
          name: 'Sofa'
        }
      ],
      bedLocations: [
        {
          name: 'Schlafzimmer'
        },
        {
          name: 'Wohnzimmer'
        },
        {
          name: 'Wohn- u. Schlafzimmer'
        }
      ]
    };
  },
  methods: {
    async saveRentObjectBed() {
      await this.$store.dispatch("rentObjectBeds/create", {
        rentObjectId: this.id,
        ...this.formData
      });
      await this.$store.dispatch("rentObjectBeds/findAll", {
        rentObjectId: this.id,
      });

      this.rentObjectBeds = JSON.parse(
        JSON.stringify(this.$store.state.rentObjectBeds.all)
      );

      this.isModalActive = false;
    },
    newRentObjectBed() {
      this.formData =  {
        type: null,
        location: null,
        width: null,
        height: null,
        length: null
      };
      this.isModalActive = true;
    },
    updateRentObjectBed(bed) {
      this.formData = {...this.formData, ...bed};
      this.isModalActive = true;
    },
    async deleteRentObjectBed(bed) {
      this.$buefy.dialog.confirm({
        title: "Bett löschen",
        message: `Sind Sie sicher, dass Sie dieses Bett <b>${bed.type} ${bed.location}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Jetzt löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("rentObjectBeds/delete", {
              id: bed.id
            });
            await this.$store.dispatch("rentObjectBeds/findAll", {
              rentObjectId: this.id,
            });
            this.rentObjectBeds = JSON.parse(
              JSON.stringify(this.$store.state.rentObjectBeds.all)
            );
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Preis konnte nicht gelöscht werden."
            );
          }
        },
      });
    },
    async reloadData() {
      await this.$store.dispatch("rentObjectBeds/findAll", {
        rentObjectId: this.id,
      });

      this.rentObjectBeds = JSON.parse(
        JSON.stringify(this.$store.state.rentObjectBeds.all)
      );
    }
  },
  async mounted() {
    await this.$store.dispatch("rentObjectBeds/findAll", {
      rentObjectId: this.id,
    });

    this.rentObjectBeds = JSON.parse(
      JSON.stringify(this.$store.state.rentObjectBeds.all)
    );
  },
};
</script>

<style lang="scss" scoped>
</style>